import { FC, ReactNode } from 'react'
import React from 'react'
import Popover from '@/components/UiElements/PopOver'
import Alert from '@/components/UiElements/Alert'
import hatchPatternFormItems from '@/components/HatchProfile/forms/hatchPatternFormItems'




type HatchProfileItemProps = {
	profile: any
	className?: string
	onDelete?: (id: string) => void
	callBack: (item:any) => void
}

const Label = ({title, value, enable = true, className}: { title: string | ReactNode; value: string | ReactNode; enable?: boolean; className?: string | null }) => {
	return (
		<div className={`py-sm px-md h-[50px] rounded-md transition-all ${enable ? "bg-gray-100 group-hover:bg-gray-200 " : "bg-gray-50 group-hover:bg-gray-100"} ${enable ? "text-gray-900 group-hover:text-gray-900" : "text-gray-400 group-hover:text-gray-900"} ${className || ""}`}>
			<p className={"text-gray-400 text-xs"}>{title}</p>
			<p className={` text-sm  capitalize `}>{value}</p>
		</div>
	)
}


const PriceListItem: FC<HatchProfileItemProps> = ({ profile, className = '', onDelete, callBack }) => {






	const handleDeleteItem = () => {
		Alert.showAlert({
			title: 'Delete hatch profile',
			isCancelable: true,
			danger: true,
			button: 'Delete!',
			message:
				<div className={'flex flex-col items-center justify-center '}>

					Are you sure you want to delete the hatch profile &quot;{profile?.name}&quot;?
				</div>,
			callBack: async (ok) => {
				if (ok && profile) {
					onDelete?.(profile.id)
				}

			},
		})
	}




	const hatch_type = hatchPatternFormItems.find(h => h.name === 'hatch_type')?.itemOptions?.list

	return (
		<div
			onClick={() => {
				callBack(profile)
			}}
			id={profile.id}
			className={`relative group active:bg-gray-100 flex py-sm  border-b-gray-200 border-b-[1px] items-center hover:bg-gray-50 cursor-pointer transition-all group gap-md px-md h-[140px] ${className} ` }
		>


			<Popover
				toggle={(open) => (
					<div
						className={` select-none w-[37px] h-[37px] min-w-[37px] ${open ? "text-white bg-gray-900" : " bg-gray-200 hover:bg-gray-700 text-gray-900 hover:text-white"}     rounded-full flex-col justify-center items-center inline-flex font-icon-regular cursor-pointer transition-all`}


					>
						<div className="text-center ">ellipsis</div>
					</div>
				)}
				placement="bottom left"
				offsetX={0}
				offsetY={10}
				menu={[

					{
						title: <span className="capitalize">Edit Profile</span>,
						icon: '',
						onClick: ()=> callBack(profile)

					},
					{
						title: <span className="capitalize">Duplicate </span>,
						icon: '',
						onClick: ()=> callBack({...profile, id: "duplicate"})

					},
					{ separator: true, className: 'my-[10px]' },
					{
						title: <span className="capitalize">Delete</span>,
						icon: '',
						className: 'hover:bg-red-100 text-red-500',
						onClick:handleDeleteItem
					}
					,]}
			/>

			<div className={' flex flex-col justify-between f-full gap-md items-start transition-all h-[100px] w-full mix-blend-multiply'}>


				<div className={`text-title-md pl-md transition-all capitalize flex flex-col gap-0  `}>
					{profile.name}
					<span className={"text-gray-400 text-text-md"}>
						{profile.description}
					</span>
				</div>



				<div className={'flex flex-row gap-sm justify-between w-full '}>

					<div className={'flex flex-row gap-sm'}>

						<Label
							title={`Patterns (${profile?.hatch_patterns?.length})`}
							value={
								profile?.hatch_patterns?.map((p: any) =>
									hatch_type?.find(opt => opt.value === p.hatch_type?.value)?.label
								).join(', ')}
							className={`w-[200px] capitalize`}
						/>



					</div>


				</div>


			</div>


		</div>
	)
}


export default PriceListItem